var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_282_4356)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4931 39.0825L30.9931 27.0825C30.767 27.0038 30.5253 26.9804 30.2883 27.0142C30.0513 27.048 29.8258 27.138 29.6306 27.2768C29.4355 27.4155 29.2765 27.599 29.1668 27.8118C29.057 28.0246 28.9999 28.2606 29 28.5V61.5C29 61.8978 29.158 62.2794 29.4393 62.5607C29.7206 62.842 30.1022 63 30.5 63C30.8978 63 31.2794 62.842 31.5607 62.5607C31.842 62.2794 32 61.8978 32 61.5V53.5669L65.4931 41.9175C65.7879 41.8155 66.0435 41.6242 66.2244 41.3701C66.4053 41.116 66.5025 40.8119 66.5025 40.5C66.5025 40.1881 66.4053 39.884 66.2244 39.6299C66.0435 39.3759 65.7879 39.1845 65.4931 39.0825ZM32 50.3906V30.6094L60.4344 40.5L32 50.3906Z",
    fill: "#FFFADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_4356",
    x1: 0,
    y1: 45,
    x2: 90,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#776D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463C01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC3);
export default __webpack_public_path__ + "static/media/c-3.7095df9d7de8e4d538226f4fecbb7500.svg";
export { ForwardRef as ReactComponent };